import { Component } from "react";

class MapInput extends Component {
  constructor(props) {
    super(props);

    const { value = {} } = props;

    this.state = {
      pairs: Object.entries(value),
    };
  }

  handleChange(event, type, index) {
    const value = event.target.value;

    this.setState((state) => {
      // slice() only copies the outer array, so the inner pair has to be copied too --
      // assigning into it directly would mutate the array still held in state.
      const pairs = state.pairs.map((pair) => pair.slice());
      const [key = "", currentValue = ""] = pairs[index] || [];

      pairs[index] = type === "key" ? [value, currentValue] : [key, value];

      return { pairs: pairs.filter(([pairKey]) => pairKey !== "") };
    });
  }

  render() {
    const { inputProps = {} } = this.props;
    const pairs = this.state.pairs.slice();
    const keys = pairs.map(([key, _]) => key);

    pairs.push(["", ""]);

    return (
      <div className="form-group">
        {pairs.map(([key, value], index) => {
          const hasName = key !== "" && inputProps.name !== undefined;
          const namePrefix = `${inputProps.name}[${index}]`;
          const hasDuplicate = [
            ...keys.slice(0, index),
            ...keys.slice(index + 1),
          ].includes(key);

          return (
            <div
              key={index}
              className={`form-group form-inline${
                hasDuplicate ? " has-error" : ""
              }`}
            >
              <input
                {...inputProps}
                type="text"
                className="form-control"
                value={key}
                onChange={(e) => this.handleChange(e, "key", index)}
                placeholder="Key"
                name={hasName ? `${namePrefix}[key]` : null}
              />
              <input
                {...inputProps}
                type="text"
                className="form-control"
                value={value}
                disabled={key === ""}
                onChange={(e) => this.handleChange(e, "value", index)}
                placeholder="Value"
                name={hasName ? `${namePrefix}[value]` : null}
              />
            </div>
          );
        })}
      </div>
    );
  }
}

export default MapInput;
